<template>
    <v-container fluid>
        <v-row v-if="isLoading">
            <v-col>
                <loading-spinner></loading-spinner>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col cols="12" md="5">
                <v-card>
                    <v-tabs v-model="currentTab" align-tabs="start" color="primary">
                        <v-tab v-for="item in tabs" :key="item.id" @click="onSelect(item)">
                            {{ item.label }}
                        </v-tab>
                    </v-tabs>
                    <v-card-text>
                        <simple-table-content :columns="tableColumns" :data="contents" />
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="7">
                <editor-card :value="content.content" @update-content="updateContent">
                    <template v-slot:header>
                        <v-row align="center">
                            <v-col class="d-flex flex-row">
                                <label class="text-body-1 pa-2">
                                    {{ $t('label.title') }}
                                </label>
                                <v-text-field v-model="content.title" dense></v-text-field>
                            </v-col>
                            <v-col class="d-flex flex-row">
                                <label class="text-body-1 pa-2">
                                    {{ $t('label.code') }}
                                </label>
                                <v-text-field v-model="content.code" dense :disabled="readonly"></v-text-field>
                            </v-col>
                        </v-row>
                    </template>

                    <template v-slot:bottom-content>
                        <v-row v-if="isAboutTab" align="center" class="mt-2">
                            <v-col cols="12" class="d-flex flex-row align-center">
                                <label class="text-body-1 pa-2">
                                    {{ $t('label.attachment') }}
                                </label>
                                <file-input class="flex-grow-1 ml-2" :key="content.idx"
                                    :initialFilePath="content.file_path || ''"
                                    :category="'homepage'"
                                    :acceptExtensions="['pdf', 'jpg', 'jpeg', 'png', 'gif']"
                                    @update-saved-file-path="updateFilePath"
                                    @update-saved-file-name="updateFileName"></file-input>
                            </v-col>
                            <v-col cols="12" class="pt-0">
                                <span class="text-caption grey--text">{{ $t('txt.homepage_attachment_hint') }}</span>
                            </v-col>
                        </v-row>
                    </template>

                    <template v-slot:bottom-buttons>
                        <v-card-actions class="mt-3">
                            <v-spacer></v-spacer>
                            <custom-button @click="handleSubmit" :label="$t('button.save')" color="primary" size="lg"
                                gradient rounded></custom-button>
                        </v-card-actions>
                    </template>
                </editor-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import SimpleTableContent from '@/components/Tables/SimpleTableContent.vue';
import EditorCard from '@/components/common/Cards/EditorCard.vue';
import CustomButton from '@/components/common/buttons/CustomButton.vue';
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';
import FileInput from '@/components/common/input/FileInput.vue';

import tabs from '@/views/ContentView/tabs';
import { getHomepageContentColumns } from '@/views/ContentView/columns';
import { savePopup, success } from '@/views/ContentView/popups';
import { homepageContentApi } from '@/api/api';


export default {
    components: {
        SimpleTableContent,
        CustomButton,
        EditorCard,
        LoadingSpinner,
        FileInput,
    },
    data() {
        return {
            tabs: tabs,
            tableColumns: getHomepageContentColumns({
                edit: this.handleEdit,
            }),
            isLoading: false,
            readonly: true,
            currentTab: tabs[0],
            contents: [],
            content: {
                idx: null,
                title: null,
                content: null,
                category: null,
                code: null,
                file_path: null,
                down_file_name: null,
                created_at: null,
                updated_at: null,
            }
        };
    },
    computed: {
        isAboutTab() {
            return this.currentTab && this.currentTab.key === 'ABOUT';
        },
    },
    methods: {
        fetchHomepageContents(category) {
            this.isLoading = true;
            homepageContentApi.getHomepageContents({ category }).then(response => {
                if (response && response.status === 200) {
                    this.contents = response.data.response  ;
                }
                this.isLoading = false;
            });
        },
        fetchHomepageContent(content) {
            this.isLoading = true;
            homepageContentApi.showHomepageContent(content).then(response => {
                if (response && response.status === 200) {
                    this.content = response.data.response;
                }
                this.isLoading = false;
            });
        },
        updateHomepageContent(content) {
            this.isLoading = true;
            return homepageContentApi.updateHomepageContent(content).then(response => {
                this.isLoading = false;
                return response && response.status === 200;
            });
        },
        handleEdit(content) {
            this.fetchHomepageContent(content);
        },
        async handleSubmit() {
            if (!this.content.idx) return;
            const isConfirmed = await savePopup();
            if (!isConfirmed) return;
            const isSuccess = await this.updateHomepageContent(this.content);
            if (isSuccess) {
                await this.fetchHomepageContent(this.content);
                await success();
            }
        },
        onSelect(tab) {
            if (this.currentTab !== tab) {
                this.currentTab = tab;
                this.fetchHomepageContents(this.currentTab.key);
            }
        },
        updateContent(newValue) {
            this.content.content = newValue;
        },
        updateFilePath(path) {
            this.content.file_path = path || null;
        },
        updateFileName(name) {
            this.content.down_file_name = name || null;
        },
    },
    mounted() {
        this.fetchHomepageContents(this.currentTab.key);
    },
};
</script>

<style scoped></style>